export const ADMIN_ROLE_ID = '00000000-0000-0000-0000-000000000001';
export const HOUSEKEEPING_ROLE_ID = '00000000-0000-0000-0000-000000000002';
export const FRONT_DESK_ROLE_ID = '00000000-0000-0000-0000-000000000003';